export default function formateObjToParamStr(paramObj) {
  const sdata = Object.keys(paramObj)
    .map((item) => {
      if (paramObj[item]) {
        return `${item}=${paramObj[item]}`;
      }
      return '';
    })
    .filter((item) => item)
    .join('&');
  return sdata;
}
